module.exports = __webpack_public_path__ + "img/60.2e192e7b.svg";